import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewChild, ViewContainerRef } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { Column } from 'src/app/ui/tables';

@Component({
  selector: 'app-table-headers',
  imports: [TableModule, NgClass, TooltipModule],
  templateUrl: './table-headers.component.html',
  styleUrl: './table-headers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableHeadersComponent {

    @ViewChild('template', { static: true }) template: any;

    columns = input.required<Column<any>[]>()

  constructor(
    private viewContainerRef: ViewContainerRef
  ) { }

    filterType: Record<Column<any>['type'], "numeric" | "text" | "date" | "boolean"> = {
    text: 'text',
    string: 'text',
    number: 'numeric',
    date: 'date',
    currency: 'numeric',
    boolean: 'boolean',
    chip: 'text',
    groupNameWithLink: 'text',
    groupArray: 'text',
    html: 'text',
    phone: 'text',
    percentage: 'numeric',
    partnerNameWithLink: 'text',
    logtype: 'numeric',
    link: 'text',
    webcastWithUrl: 'text',
    tripIdWithLink: 'text',
    linkToPpm: 'text',
    groupIdWithLink: 'text',
    list: 'text',
    fraction: 'numeric',
    email: 'text',
  }


  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template)
  }

}
